import { render } from "./Main.vue?vue&type=template&id=01be0c5b&scoped=true"
import script from "./Main.vue?vue&type=script&lang=js"
export * from "./Main.vue?vue&type=script&lang=js"

import "./Main.vue?vue&type=style&index=0&id=01be0c5b&lang=css"
import "./Main.vue?vue&type=style&index=1&id=01be0c5b&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-01be0c5b"

export default script